<script setup lang="ts">
import { useTheme } from '@composables/theme';

const props = withDefaults(defineProps<{
  variant?: 'default' | 'active';
}>(), {
  variant: 'default',
});

defineSlots<{
  default: void;
}>();

const theme = useTheme();
</script>

<template>
  <div class="t-chip" :class="[`t-chip--${props.variant}`]">
    <slot />
  </div>
</template>

<style scoped lang="scss">
* {
  margin: 0;
  box-sizing: border-box;
}

.t-chip {
  display: inline-flex;
  align-items: center;
  border-radius: 32px;
  border: 0.5px solid v-bind('theme.colors.gray.dark3');
  padding: 4px 8px;
  gap: 4px;
  background-color: v-bind('theme.colors.background');

  :deep(*) {
    font-size: 0.75rem;
    line-height: 18px;
    color: v-bind('theme.colors.gray.dark3');
  }

  &--active {
    border: 0.5px solid v-bind('theme.colors.primary.main');
    background-color: v-bind('theme.colors.primary.light5');

    :deep(*) {
      color: v-bind('theme.colors.primary.main');
    }
  }
}
</style>
